import { FC, Fragment, MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Popover, Stack, Typography } from '@mui/material';
import { Tooltip } from '@mui/material';

import { Button } from '@components/base';
import useSearchAndFilter from '@modules/layouts/hooks/useSearchAndFilter';
import OrderProvidersBy from '@modules/layouts/pages/components/PageView/PageAccordions/OrderProvidersBy';

const OrderProvidersByPopup: FC = () => {
  const { t } = useTranslation();

  const {
    isReadonly,
    searchQuery: { orderProvidersBy },
    setOrderProvidersBy,
  } = useSearchAndFilter();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);

  const hasValue = Object.values(orderProvidersBy || {}).some(Boolean);

  return (
    <Fragment>
      <Tooltip title={''}>
        <Stack alignItems='center' direction='row' spacing={1}>
          {hasValue && (
            <Typography variant='caption' whiteSpace='nowrap'>
              {t('orderProvidersBy')}
            </Typography>
          )}

          <Button
            color='inherit'
            disabled={isReadonly}
            onClick={handleOpen}
            rightIcon='chevronDown'
          >
            {hasValue
              ? [orderProvidersBy?.id, orderProvidersBy?.type].filter(Boolean).join(', ')
              : t('orderProvidersBy')}
          </Button>
        </Stack>
      </Tooltip>

      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        onClose={() => setAnchorEl(null)}
        open={open}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Stack maxWidth={1} width={320}>
          <Stack p={1.5} spacing={2}>
            <OrderProvidersBy
              headingProps={{ variant: 'h5' }}
              providerIdentifier={orderProvidersBy?.id}
              serviceType={orderProvidersBy?.type}
              setProviderIdentifier={id => setOrderProvidersBy(prev => ({ ...prev, id }))}
              setServiceType={type => setOrderProvidersBy(prev => ({ ...prev, type }))}
            />
          </Stack>

          <Box display='flex' justifyContent='flex-end' p={1} pt={0}>
            <Button onClick={() => setOrderProvidersBy(undefined)}>{t('reset')}</Button>
          </Box>
        </Stack>
      </Popover>
    </Fragment>
  );
};

export default OrderProvidersByPopup;
